/**
 * @enum {string}
 */
var _ol_ViewProperty_ = {
  CENTER: 'center',
  RESOLUTION: 'resolution',
  ROTATION: 'rotation'
};

export default _ol_ViewProperty_;



//////////////////
// WEBPACK FOOTER
// ./~/ol/viewproperty.js
// module id = 954
// module chunks = 0